/**
 * @file AvitoCabinetLayout.tsx
 * @description Layout-обёртка раздела «Avito» в кабинете магазина (phase14.0).
 *
 * Содержит навигацию по подразделам (Dashboard / Листинги / Заказы / Отзывы / Журнал)
 * и Outlet для дочерних роутов. Mobile-first: горизонтальный скролл табов на узких экранах.
 */

import { NavLink, Outlet } from "react-router";

const tabs = [
  { to: "", end: true, label: "Обзор" },
  { to: "listings", label: "Листинги" },
  { to: "orders", label: "Заказы" },
  { to: "reviews", label: "Отзывы" },
  { to: "sync-log", label: "Журнал синхр." },
];

export function AvitoCabinetLayout() {
  return (
    <div className="flex flex-col gap-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-on-surface">Avito</h1>
        <p className="text-sm text-on-surface-variant max-w-2xl">
          Синхронизация каталога-листингов, заказов Avito-Доставки и отзывов с площадкой
          Avito через официальное API. Подключение настраивается в платформенных
          интеграциях.
        </p>
      </header>
      <nav className="flex gap-1 overflow-x-auto border-b border-outline-variant pb-1 -mx-4 px-4 md:mx-0 md:px-0">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to || "index"}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              [
                "whitespace-nowrap px-4 py-2 text-sm font-medium rounded-t-md transition-colors",
                isActive
                  ? "text-primary border-b-2 border-primary -mb-[1px]"
                  : "text-on-surface-variant hover:text-on-surface",
              ].join(" ")
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
